// components/ChatWindow.js
import { useState, useEffect, useRef } from 'react';

export default function ChatWindow({ role, user, userId, socket, isSocketConnected }) {
	const [roomName, setRoomName] = useState('');
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [messages, setMessages] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
    const [replyText, setReplyText] = useState('');
	const messagesEndRef = useRef(null);

    const loadUsers = async () => {
        try {
            const res = await fetch('/api/users');
            const data = await res.json();
            setUsers(data);
        } catch (err) {
            console.error('Error cargando usuarios:', err);
        }
    };

    const loadMessages = async (userId) => {
        try {
            const res = await fetch(`/api/messages/${userId}`);
            const data = await res.json();
            setMessages(data);
        } catch (err) {
            console.error('Error cargando mensajes:', err);
        }
    };

	// Scroll al último mensaje
	useEffect(() => {
		scrollToBottom();
	}, [messages]);

	useEffect(() => {
		if (userId) {
			setRoomName(`user_${userId}`);
		}
	}, [selectedUser]);

	useEffect(() => {
		if (socket && roomName) {
			socket.emit('joinRoom', roomName);
		}
	}, [roomName]);

	useEffect(() => {
		if (!socket) return;


		const handleNewMessage = (message) => {
			console.log("ESCUCHANDO", message)
			setMessages(prev => [...prev, message]);
		};

		const handleMessageHistory = (history) => {
			setMessages(history);
			setIsLoading(false);
		};

		// Configurar event listeners
		if (roomName) {
			console.log("ROOMNAME #45", roomName)
			//socket.emit('joinRoom', {room: roomName});
		}
		socket.on('new-message', handleNewMessage);
		socket.on('message_history', handleMessageHistory);

		// Solicitar historial cuando el socket esté conectado
		if (isSocketConnected) {
			//socket.emit('get_history');
			//socket.emit('joinRoom', roomName); //emite para unirse a la sala
			socket.emit('get_history');
		}

		// Cleanup listeners
		return () => {
			socket.off('new-message', handleNewMessage);
			socket.off('message_history', handleMessageHistory);
		};
	}, [socket, isSocketConnected]);

    useEffect(() => {
        loadUsers();

        socket.on('new_message', (msg) => {
            if (selectedUser?.user_id === msg.user_id) {
                setMessages(prev => [...prev, msg]);
            }
        });

        return () => socket.off('new_message');
    }, [selectedUser]);

    useEffect(() => {
        if (selectedUser) {
            loadMessages(selectedUser.user_id);
        } else {
            setMessages([]);
        }
    }, [selectedUser]);

    const handleSendReply = async () => {
        if (!selectedUser || !replyText.trim()) return;

        const payload = {
            userId: selectedUser.user_id,
            message: replyText.trim(),
			timestamp: new Date().toISOString()
        };

        try {
            await fetch('/api/messages/reply', { //nuevo enpoint para respuestas del admin
                method: 'POST',
                headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${localStorage.getItem('token')}`
				},
                body: JSON.stringify(payload),
            });

            // Añadir al chat como mensaje del admin
            const newMsg = {
                user_id: selectedUser.user_id,
                sender: 'admin',
                message: replyText.trim(),
                timestamp: new Date().toISOString(),
            };

            setMessages(prev => [...prev, newMsg]);
            setReplyText('');
        } catch (err) {
            alert('No se pudo enviar el mensaje');
        }
    };

	const scrollToBottom = () => {
		messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
	};

    return (
        <div className="flex flex-col h-[500px] bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden">
            {/* Header */}
            <div className="bg-white dark:bg-gray-800 shadow px-6 py-4">
                <h1 className="text-2xl font-semibold text-gray-800 dark:text-gray-100">Panel de Soporte</h1>
            </div>

            <div className="flex flex-1 overflow-hidden">
                {/* Lista de usuarios */}
                <div className="w-80 bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 flex flex-col">
                    <div className="p-4 border-b border-gray-200 dark:border-gray-700">
                        <h2 className="text-lg font-medium text-gray-700 dark:text-gray-200">Usuarios</h2>
                    </div>
                    <div className="flex-1 overflow-y-auto">
                        {users.length === 0 ? (
                            <p className="text-center text-gray-500 dark:text-gray-400 p-4">No hay mensajes</p>
                        ) : (
                            users.map((user) => (
                                <div
                                    key={user.user_id}
                                    onClick={() => setSelectedUser(user)}
                                    className={`p-4 border-b border-gray-100 dark:border-gray-700 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700 ${selectedUser?.user_id === user.user_id ? 'bg-blue-50 dark:bg-gray-700 border-l-4 border-l-blue-500' : ''
                                        }`}
                                >
                                    <p className="font-medium text-gray-800 dark:text-gray-200">
                                        {user.user_name || `Usuario ${user.user_id}`}
                                    </p>
                                    <p className="text-sm text-gray-600 dark:text-gray-300 truncate mt-1">{user.message}</p>
                                    <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">
                                        {new Date(user.timestamp).toLocaleTimeString()}
                                    </p>
                                </div>
                            ))
                        )}
                    </div>
                </div>

                {/* Chat activo */}
                <div className="flex-1 flex flex-col">
                    {selectedUser ? (
                        <>
                            {/* Chat Header */}
                            <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-6 py-3">
                                <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200">
                                    Chat coN {selectedUser.user_name || selectedUser.user_id}
                                </h3>
                            </div>

                            {/* Mensajes */}
                            <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-gray-100 dark:bg-gray-800">
                                {messages.length === 0 ? (
                                    <p className="text-center text-gray-500 dark:text-gray-400">No hay mensajes aún</p>
                                ) : (
                                    messages.map((message, i) => (
                                        <div
                                            key={i}
                                            className={`flex ${message.sender === 'user' || (message.sender === 'admin' || message.from_sender === 'admin') ? 'justify-start' : 'justify-end'}`}
                                        >
                                            <div
                                                className={`max-w-xs lg:max-w-md px-4 py-2 rounded-2xl shadow-sm ${ message.sender === 'user' || (message.sender === 'admin' || message.from_sender === 'admin')
                                                        ? 'bg-blue-500 text-white rounded-bl-none'
                                                        : 'bg-gray-200 dark:bg-gray-600 text-gray-900 dark:text-gray-100'
                                                    }`}
                                            >
                                                <p className="text-sm">{message.message}</p>
                                                <p className="text-xs opacity-90 mt-1">
                                                    {new Date(message.timestamp).toLocaleTimeString()}
                                                </p>
                                            </div>
                                        </div>
                                    ))
                                )}
								<div ref={messagesEndRef} />
                            </div>

                            {/* Input */}
                            <div className="bg-white p-4 border-t border-gray-200">
                                <div className="flex gap-2">
                                    <textarea
                                        value={replyText}
                                        onChange={(e) => setReplyText(e.target.value)}
                                        onKeyPress={(e) => e.key === 'Enter' && !e.shiftKey && handleSendReply()}
                                        placeholder="Escribe una respuesta..."
                                        rows="1"
                                        className="flex-1 resize-none border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    />
                                    <button
										disabled={!replyText.trim() || !isSocketConnected}
                                        onClick={handleSendReply}
                                        className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-2 rounded-lg transition"
                                    >
                                        Enviar
                                    </button>
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="flex-1 flex items-center justify-center bg-gray-100">
                            <p className="text-gray-500">Selecciona un usuario para comenzar el chat</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}